import { createAction } from 'redux-actions';

import { FETCH_ALLEYE_PROVIDER_KPI, LOADING_ALLEYE_PROVIDER_KPI } from './consts';

export const fetchAlleyeProviderKPI = createAction(FETCH_ALLEYE_PROVIDER_KPI);
export const setIsLoadingTrue = createAction(LOADING_ALLEYE_PROVIDER_KPI);
